import { gql, TypedDocumentNode } from '@apollo/client';
import { useFeatureFlag } from '@moda/portal-stanchions';
import {
  RefreshedMobileSiteNavMenuQuery,
  RefreshedMobileSiteNavMenuQueryVariables
} from '../../../generated/types/RefreshedMobileSiteNavMenuQuery';
import { useSkippableQuery } from '../../../hooks/useSkippableQuery';

export const REFRESHED_MOBILE_SITE_NAV_MENU_QUERY: TypedDocumentNode<
  RefreshedMobileSiteNavMenuQuery,
  RefreshedMobileSiteNavMenuQueryVariables
> = gql`
  query RefreshedMobileSiteNavMenuQuery($vertical: String!, $show_beauty: Boolean) {
    displayPage(slug: $vertical, gender: $vertical, show_beauty: $show_beauty) {
      data: refreshed_mobile_nav {
        __typename
        tabs {
          __typename
          label
          mainCategories: main_categories {
            __typename
            label
            url
            mainCategoryItems: main_category_items {
              __typename
              subItems: sub_items {
                __typename ## MobileNavSubItem
                label
                listLinks: list_links {
                  label
                  url
                  isHighlighter: highlighter
                }
              }
            }
          }
          imageCategories: image_categories {
            name: category_name
            images {
              image
              headline
              anchor
              secondAnchor: second_anchor
              url
            }
          }
        }
      }
    }
  }
`;

export const useRefreshedMobileSiteNavMenuQuery = () => {
  const isBeautySectionEnabled = useFeatureFlag('beauty', [
    { default: false },
    { if: true, then: true }
  ]);

  const { data, loading, error } = useSkippableQuery(REFRESHED_MOBILE_SITE_NAV_MENU_QUERY, {
    variables: { vertical: 'women', show_beauty: isBeautySectionEnabled }
  });

  return { tabs: data?.displayPage?.data.tabs, loading, error };
};
